import { DiscoverAccountObject } from "../../Models/Response/Account/DiscoverAccount";

const intiState = {
  accounts: Array<DiscoverAccountObject>(),
};

export default function accounts(state = intiState, action: any) {
  switch (action.type) {
    case "DISCOVER_ACCOUNT":
      return {
        ...state,
        accounts: action.payload.accounts,
      };
    default:
      return state;
  }
}
